import { useMutation } from "react-query";
import http from "infra/http";

function useExportarRemessa() {
  return useMutation(async (ids: string[]) => {
    const { data } = await http.post(
      `/v1/conta/exportar-remessa`,
      {
        ids,
      },
      // {
      //   responseType: "arraybuffer",
      // }
    );

    return data as { nome: string; bytes: string }[];
  });
}

export default useExportarRemessa;
